import React from 'react';
import { DiscussionEmbed } from "disqus-react"
import styled from "styled-components";

const CommentsInner = styled.div`
  width: calc(100% - 50px);
  max-width: 820px;
  margin: 0 auto;
  margin-bottom: 50px;
  padding-top: 40px;
`;

const Comments = ({ slug, title }) => {

  const disqusConfig = {
    shortname: "goodbyecz",
    config: { identifier: slug, title },
  }

  return (
    <CommentsInner id="komentare">
      <h2>Komentáře</h2>
      <DiscussionEmbed {...disqusConfig} />
    </CommentsInner>
  );
}

export default Comments;
